<template>
  <div class="pb-2">
    <b-row class="px-2 d-flex align-items-center">
      <b-col md="3">
        <h3>Billing Info</h3>
      </b-col>
      <b-col md="9">
        <b-button
          v-b-modal.billToEdit
          class="main-navigation-button w-1 edit_button"
          variant="white"
          btn-color="primary1"
        >
          <v-avatar size="25">
            <img src="img/Edit.png" />
          </v-avatar>
        </b-button>
      </b-col>
      <b-modal
        id="billToEdit"
        title="Bill TO"
        header-class="header-nipige-class"
        size="lg"
        centered
        hide-footer
      >
        <sbillmodel>
          <template v-slot:footer-button="data">
            <b-button
              class="btn btn-block mt-3"
              btn-color="primary"
              @click="OfficeToNext(data.data)"
              >Update</b-button
            >
          </template>
        </sbillmodel>
      </b-modal>
    </b-row>

    <b-row class="px-2 mt-1">
      <b-col>
        <b-row>
          <b-col md="6">
            <p class="left-text">Billing Name :</p>
          </b-col>
          <b-col md="6">
            <p class="right-text">
              {{ officeData }}
            </p>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col class="line" md="6">
            <p class="left-text">Category :</p>
          </b-col>
          <b-col md="6">
            <p class="right-text">
              {{ billData && billData.category }}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="m-2 line-bottom"></b-row>
    <b-row class="px-2">
      <b-col>
        <b-row>
          <b-col md="6">
            <p class="left-text">Phone # :</p>
          </b-col>
          <b-col md="6">
            <p class="right-text">
              {{ billData && billData.phone }}
            </p>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col class="line" md="6">
            <p class="left-text">Email Id :</p>
          </b-col>
          <b-col md="6">
            <p class="right-text">
              {{ billData && billData.email }}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="m-2 line-bottom"></b-row>
    <b-row class="px-2">
      <b-col>
        <b-row>
          <b-col md="3">
            <p class="left-text">Billing Address :</p>
          </b-col>
          <b-col md="9">
            <p class="right-text">
              {{ partnerAddress }}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import sbillmodel from "@/components/Partner/PartnerEdit/BillToStepper";
import { mapGetters } from "vuex";
export default {
  components: {
    sbillmodel,
  },
  data() {
    return {
      billToData: null,
    };
  },
  props: ["billData"],
  computed: {
    ...mapGetters({ partnerAllData: "partner/GetPartnerData" }),
    officeData() {
      if (this.billToData) {
        return this.billToData.officeName;
      } else {
        return null;
      }
    },
    partnerAddress() {
      if (this.billData?.office?.address) {
        const { street1, street2, city, state, zip } = this.billData.office.address;
        return `${street1 ? street1 + ', ' : ''}${street2 ? street2 + ', ' : ''}${city}, ${state}-${zip}`;
      }
    },
  },
  methods: {
    async OfficeToNext(data) {
      let payload = {
        id: this.partnerAllData._id,
        data: {
          billTo: data,
          category: data.category.value,
        },
      };
      this.$store
        .dispatch("partner/updatePartner", payload)
        .then((result) => {
          this.$swal({
            title: "Success",
            text: "Partner Edited successfully!",
            type: "success",
          });
          this.$emit("reload-partner", this.partnerAllData._id);
          this.$root.$emit("bv::hide::modal", "billToEdit", "#btnShow");
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: "Could not Edited partner",
            type: "error",
          });
        });
    },
  },
  mounted() {
    if (
      Array.isArray(this.billData?.bill_to) &&
      this.billData?.bill_to?.length > 0
    ) {
      this.billToData = this.billData?.bill_to[0];
    } else {
      this.billToData = this.billData?.office;
    }
  },
};
</script>
<style scoped>
.line {
  border-left: 1px dashed #c2c2c2;
}
.line-bottom {
  border-bottom: 1px dashed #c2c2c2;
}
.text-style {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: rgba(143, 143, 143, 0.87);
}
.left-text {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 500;
  color: #58585b;
}
.right-text {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}
.list-style {
  list-style-type: none;
}
[btn-color="primary1"] {
  outline: none !important;
  border-radius: 50%;
  height: 39px;
  width: 39px;
  padding: 0;
}
[btn-special="primary1"] {
  border-radius: 50%;
}
@media (max-width: 767px) {
  .my-content {
    display: none;
  }
}
@media (min-width: 767px) {
  .mobile-responsive {
    display: none;
  }
}
@media (max-width: 767px) {
  .edit_button {
    margin-top: -34px;
  }
}
</style>
